module.exports = __webpack_public_path__ + "media/images/common/icon-ellipsis-eb8fd03b1afe97d2dbfa0b3cf05c6c7f.png";